import { setThemeVariables } from '@corva/ui/utils/themeVariables';
import { isReportsPage } from '~/utils/reports';

if (isReportsPage) setThemeVariables(false);
